'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/Checkbox.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
 Id={"ceckboxAGB"} 
 onClick={()=>{this.setState({AGB:$("#ceckboxAGB").val()})}}
label={}

optional:
ref={"AGB"}
name={}
value={}
Float={}
*/

// eslint-disable-next-line react/prefer-stateless-function
var Checkbox = function (_Component) {
    _inherits(Checkbox, _Component);

    function Checkbox(props) {
        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

        _this.state = {};
        _this.state.OnKeyDown = _this.props.OnKeyDown;
        return _this;
    }

    _createClass(Checkbox, [{
        key: 'removeFocusedElements',
        value: function removeFocusedElements() {
            var elements = document.getElementsByClassName('extendedButton');
            var i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedButton');
            }

            elements = document.getElementsByClassName('focusedCheckBox');
            i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedCheckBox');
            }
        }
    }, {
        key: 'focus',
        value: function focus(id) {
            (0, _jquery2.default)("#" + id).select();

            this.removeFocusedElements();

            (0, _jquery2.default)("#div_" + id).addClass("focusedCheckBox");
        }
    }, {
        key: 'tab',
        value: function tab(event, me) {
            if (event) {
                if (event.keyCode === 13 || event.keyCode === 9) {

                    var docs = document.querySelectorAll(' div.ss-selected-option,input,button,select');
                    var maxId = docs.length;
                    var aktive = document.activeElement.id;
                    var i = void 0;

                    for (i = 0; i <= maxId - 1; i++) {

                        if (docs[i].id === aktive) {

                            if (i === maxId - 1) {

                                this.removeFocusedElements();

                                docs[i].blur();
                                break;
                            } else {
                                if (event.shiftKey && event.keyCode === 9) {

                                    for (var j = i - 1; j >= 0; j--) {
                                        if (!docs[j].readOnly) {

                                            docs[j].focus();
                                            break;
                                        } else if (docs[j].className === "ss-selected-option") {

                                            var _event = new Event("click");
                                            docs[j].dispatchEvent(_event);
                                            break;
                                        }
                                    }
                                } else {

                                    for (var _j = i + 1; _j <= maxId - 1; _j++) {
                                        if (!docs[_j].readOnly) {

                                            docs[_j].focus();
                                            break;
                                        } else if (docs[_j].className === "ss-selected-option") {

                                            var _event2 = new Event("click");
                                            docs[_j].dispatchEvent(_event2);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var float = 'left';
            if (this.props.Float) {
                float = this.props.Float;
            }
            var marginLeft = '0px';
            if (this.props.MarginLeft) {
                marginLeft = this.props.MarginLeft;
            }

            var id = "div_" + this.props.Id;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { 'for': this.props.Id, className: 'checkboxLabel' },
                    this.props.label
                ),
                _react2.default.createElement(
                    'div',
                    { id: id, style: { float: float, marginLeft: marginLeft } },
                    _react2.default.createElement('input', {
                        type: 'checkbox',
                        className: 'checkbox',
                        id: this.props.Id,
                        name: this.props.name,
                        value: this.props.value,
                        onFocus: function onFocus() {
                            _this2.focus(_this2.props.Id);
                        },
                        onClick: ((0, _jquery2.default)("#div_" + this.props.Id).removeClass(), this.props.onClick),
                        onBlur: function onBlur(e) {
                            if (_this2.props.OnBlur) {
                                _this2.props.OnBlur();
                            }_this2.tab(e, _this2);
                        },
                        onKeyDown: function onKeyDown(e) {
                            if (e.keyCode === 9) {
                                e.preventDefault();
                            }if (_this2.state.OnKeyDown) {
                                _this2.state.OnKeyDown();
                            }_this2.tab(e, _this2);
                        }
                    })
                )
            );
        }
    }]);

    return Checkbox;
}(_react.Component);

exports.default = Checkbox;